export const PAGINATION = 'pagination';
export const PER_PAGE = 'perPage';
export const PAGE_NUMBER = 'page';
export const TOTAL_PAGES = 'totalPages';

export const DEFAULT_START_PAGE = 1;
export const DEFAULT_PER_PAGE = 10;
